import m from "../../geodata/es2015/netherlandsHigh";
window.am4geodata_netherlandsHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/netherlandsHigh.js
// module id = null
// module chunks = 